import React from 'react';
import { useNavigate } from 'react-router-dom';

export const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#FCFBF9] px-4">
            <div className="text-center max-w-md">
                <div className="mb-8">
                    <h1 className="text-9xl font-bold text-primary-500 mb-4">404</h1>
                    <h2 className="text-3xl font-bold text-grayscale-1200 mb-4 font-space-grotesk">
                        Page Not Found
                    </h2>
                    <p className="text-grayscale-700 text-lg mb-8 font-space-grotesk">
                        The page you're looking for doesn't exist or has been moved.
                    </p>
                </div>
                
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <button
                        onClick={() => navigate('/')}
                        className="px-6 py-3 bg-primary-500 text-white rounded-lg font-grotesk font-medium hover:bg-primary-600 transition-colors"
                    >
                        Go to Homepage
                    </button>
                    <button
                        onClick={() => navigate(-1)}
                        className="px-6 py-3 bg-grayscale-200 text-grayscale-1200 rounded-lg font-grotesk font-medium hover:bg-grayscale-300 transition-colors"
                    >
                        Go Back
                    </button>
                </div>

                <div className="mt-12 pt-8 border-t border-grayscale-300">
                    <p className="text-sm text-grayscale-600 mb-4 font-space-grotesk">
                        You might be looking for:
                    </p>
                    <div className="flex flex-col gap-2">
                        <a
                            href="/about"
                            className="text-primary-500 hover:text-primary-600 underline font-space-grotesk"
                        >
                            About Us
                        </a>
                        <a
                            href="/privacy-policy"
                            className="text-primary-500 hover:text-primary-600 underline font-space-grotesk"
                        >
                            Privacy Policy
                        </a>
                        <a
                            href="/terms-of-service"
                            className="text-primary-500 hover:text-primary-600 underline font-space-grotesk"
                        >
                            Terms of Service
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};
